import sortBy from 'lodash/sortBy';
import without from 'lodash/without';
import uniqBy from 'lodash/uniqBy';
import { BADGES_FILTER_OPTIONS, ASSETS_FILTER_OPTIONS } from '../modules/clients/constants';

/**
 * Sort RTC data items
 * @param {array} RTCItems
 * @returns {array} sorted array
 */
export const sortByClientDevelopmentCategory = (RTCItems) => {
  return sortBy(RTCItems, ['name']);
};

/**
 * Get all unique action types for the specific category and the respective count of RTC's
 * @param {array} categoryRTCs
 * @returns {Array <actionType: String, amount: Number>}
 */
export const getCategoryActionTypes = (categoryRTCs) => {
  return uniqBy(categoryRTCs, 'actionType').reduce((acc, { actionType }) => {
    if (actionType) {
      const categoryRTCAmount = categoryRTCs.filter((categoryRTC) => categoryRTC.actionType === actionType).length;
      return [
        ...acc,
        {
          value: actionType,
          label: actionType,
          amount: categoryRTCAmount,
        },
      ];
    }
    return acc;
  }, []);
};

/**
 * Get filters collection for FilterChips component
 * @param {Object} filters
 * @returns {Array <label: String, clear: function>}
 */
export const getRTCFilterLabels = (filters) => {
  const labels = [];
  if (filters.actionTypes) {
    filters.actionTypes.forEach((actionType) => {
      labels.push({
        label: actionType,
        clear(filters, setFilters) {
          setFilters({
            ...filters,
            actionTypes: without(filters.actionTypes, actionType),
          });
        },
      });
    });
  }

  if (filters.badges) {
    filters.badges.forEach((badge) => {
      labels.push({
        label: BADGES_FILTER_OPTIONS.reduce((acc, curr) => {
          if (curr.value === badge) return `No ${curr.label}`;

          return acc;
        }, ''),
        clear(filters, setFilters) {
          setFilters({
            ...filters,
            badges: without(filters.badges, badge),
          });
        },
      });
    });
  }

  if (filters.assets) {
    filters.assets.forEach((asset) => {
      labels.push({
        label: ASSETS_FILTER_OPTIONS.reduce((acc, curr) => {
          if (curr.value === asset) return curr.label;

          return acc;
        }, ''),
        clear(filters, setFilters) {
          setFilters({
            ...filters,
            assets: without(filters.assets, asset),
          });
        },
      });
    });
  }

  return labels;
};
